export const thongTinXuatHoaDon = {
  sections: {
    list: { title: 'Thông tin xuất hóa đơn' },
  },
  fields: {
    customerId: 'Khách hàng (ID)',
    customer: 'Khách hàng',
    ten: 'Tên công ty lấy thuế',
    buyerName: 'Tên người mua',
    taxCode: 'Mã số thuế',
    invoiceAddress: 'Địa chỉ lấy thuế',
    invoiceProvince: 'Tỉnh/Thành',
    invoiceWard: 'Phường/Xã',
    soCCCD: 'Số CCCD',
    soHoChieu: 'Số hộ chiếu',
    invoiceEmail: 'Email hóa đơn',
    invoicePhone: 'SĐT công ty',
    daiDienCongTy: 'Đại diện công ty',
    chucVu: 'Chức vụ',
    bankName: 'Tên ngân hàng',
    bankAccount: 'Số tài khoản',
    bankAccounts: 'Số tài khoản',
    bankAccountCount: '{count} STK',
    accountHolder: 'Tên STK',
    default: 'STK mặc định',
    defaultCompany: 'CTY xuất HĐ mặc định',
    defaultYes: 'Mặc định',
    defaultNo: '—',
    createdAt: 'Ngày tạo',
    updatedAt: 'Ngày cập nhật',
    actions: 'Thao tác',
  },
  actions: {
    addStk: 'Thêm STK',
    removeStk: 'Xóa STK',
  },
  inline: {
    itemTitle: 'CTY xuất hóa đơn',
  },
  filter: {
    searchPlaceholder: 'Tên CTY, MST hoặc SĐT',
    customerPlaceholder: 'Tìm khách hàng…',
    defaultAll: 'Tất cả',
    defaultYes: 'Chỉ CTY mặc định',
    defaultNo: 'Không mặc định',
  },
  import: {
    failed: 'Import thất bại',
    menu: {
      cty: 'Import CTY lấy thuế',
      taiKhoan: 'Import số tài khoản',
      ctyTaiKhoan: 'Import tổ hợp (CTY + tài khoản)',
    },
  },
  placeholders: {
    provinceEmpty: '— Chọn Tỉnh/Thành —',
    wardEmpty: '— Chọn Phường/Xã —',
    ten: 'VD: Công ty TNHH ABC',
    invoiceEmail: 'VD: ketoan@cty.com; sales@cty.com',
  },
  titles: {
    add: 'Thêm CTY xuất hóa đơn',
    edit: 'Sửa CTY xuất hóa đơn',
  },
  messages: {
    noData: 'Chưa có CTY xuất hóa đơn',
    loadError: 'Không tải được dữ liệu',
    invalidContext: 'Thiếu mã khách hàng hợp lệ trên URL.',
    customerRequired: 'Vui lòng chọn khách hàng.',
    createSuccess: 'Đã tạo thông tin xuất hóa đơn',
    updateSuccess: 'Đã cập nhật thông tin xuất hóa đơn',
    deleteSuccess: 'Đã xóa thông tin xuất hóa đơn',
    notFound: 'Không tìm thấy thông tin xuất hóa đơn',
    confirmDelete: 'Xóa thông tin xuất hóa đơn «{name}»?',
    listSummary: 'Tổng số {count} CTY xuất hóa đơn',
  },
}
